import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'

import head from 'lodash/head'
import flatMap from 'lodash/flatMap'

const computeSkuSpecsRow = (skuSpecifications) => {
  const skuSpecificationsLabels = skuSpecifications.map((specification) =>
    head(specification.FieldValues)
  )
  return flatMap(skuSpecificationsLabels, (specification, index, array) => {
    const isLast = index === array.length - 1
    if (isLast) {
      return [
        <span className="pr3" key={index}>
          {specification}
        </span>,
      ]
    }
    return [
      <span className="pr3" key={index}>
        {specification}
      </span>,
      <span key={`${index}-separator`} className="pr3 mv5 c-muted-3">
        {'|'}
      </span>,
    ]
  })
}

function SkuLabelRow({ skuSpecifications }) {
  return (
    <div className="t-small pt4 c-muted-1">
      {computeSkuSpecsRow(skuSpecifications)}
    </div>
  )
}

SkuLabelRow.defaultProps = {
  skuSpecifications: [],
}

SkuLabelRow.propTypes = {
  skuSpecifications: PropTypes.array,
}

export default injectIntl(SkuLabelRow)
